import { mapGetters } from 'vuex';
export default {
  methods: {
    validateCustomerCode() {
      return this.$getLocalStorageCustomer() !== null
        ? this.$getLocalStorageCustomer()
        : this.user.custumer_code;
    },
    validateRegionalManagerCode() {
      const regionalCode = this.$getLocalStorageRegional();

      if (regionalCode !== null) return regionalCode;

      if (!this.$hasAnyRole(['IELRegManager']))
        return '0' + this.user.employee_number;

      return '';
    },
    validateSellerCode() {
      return this.$getLocalStorageSeller() !== null
        ? this.$getLocalStorageSeller()
        : this.user.employee_number;
    },
    validateManagerCode() {
      return this.$getLocalStorageManager() !== null
        ? this.$getLocalStorageManager()
        : '0' + this.user.employee_number;
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
};
